import { Component, inject, viewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BasicDialogComponent } from '../../../../shared/components/basic-dialog/basic-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatToolbarModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  readonly menuTrigger = viewChild.required(MatMenuTrigger);
  readonly dialog = inject(MatDialog);

  openDialog() {
    const dialogRef = this.dialog.open(BasicDialogComponent);
    dialogRef.afterClosed().subscribe(() => console.log('Dialog closed'));
  }
}
